import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { logoutUser } from "./authThunks";
import { formatDate, formattedDate } from "../../utils/func";

const API_BASE = process.env.REACT_APP_API_BASE;
// Thunk to fetch referrals for the logged-in member
export const fetchOnboardingReferrals = createAsyncThunk(
  "onboardingReferrals/fetchAll",
  async (_, thunkAPI) => {
    try {
      const res = await fetch(`${API_BASE}/api/onboarding-referrals`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const json = await res.json();

      if (!res.ok) {
        return thunkAPI.rejectWithValue(
          json?.message || "Failed to fetch referrals"
        );
      }

      // Transform API response into flat table rows
      const transformed = (json.data || []).map((item) => ({
        friend_name: `${item.referred_id?.first_name || ""} ${item.referred_id?.last_name || ""
          }`.trim(),
        friend_email: item.referred_id?.email_address || "-",
        reward: item.reward_history_id
          ? `£${item.reward_history_id.reward_amount}`
          : `£${item.reward_amount}`,
        reward_status: item.reward_status || "-",
        date_referred: item.created_at
          ? formattedDate(item.created_at)
          : "-",
      }));

      return transformed;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message || "Network error");
    }
  }
);

const onboardingReferralsSlice = createSlice({
  name: "onboardingReferrals",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOnboardingReferrals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOnboardingReferrals.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchOnboardingReferrals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default onboardingReferralsSlice.reducer;
